export const testItenarary = {
  code: 'RD11AD04',
  media: {
    images: [
      {
        path: '/content/dam/royal/data/ports/juneau/juneau-alaska-pink-flowers-nature-mountains-green-blue-skies.jpg',
        __typename: 'ImageMedia',
      },
      {
        path: '/content/dam/royal/data/ports/ketchikan/ketchikan-alaska-things-to-do-misty-fjords-national-monument-trees-ocean.jpg',
        __typename: 'ImageMedia',
      },
      {
        path: '/content/dam/royal/data/ports/seward/seward-alaska-resurrection-bay-mountainside-ocean-kayaking-nature.jpg',
        __typename: 'ImageMedia',
      },
      {
        path: '/content/dam/royal/data/ports/sitka/sitka-alaska-coastal-town-seascape-views.jpg',
        __typename: 'ImageMedia',
      },
      {
        path: '/content/dam/royal/data/ports/skagway/skagway-alaska-chilkat-peninsula.jpg',
        __typename: 'ImageMedia',
      },
      {
        path: '/content/dam/royal/data/ports/hubbard/hubbard-glacier-alaska-icy-glacier-mountainside.jpg',
        __typename: 'ImageMedia',
      },
      {
        path: '/content/dam/royal/data/ports/inside-passage-british-columbia/inside-passage-vancouver-island-british-columbia-ocean-mountain.jpg',
        __typename: 'ImageMedia',
      },
    ],
    __typename: 'Media',
  },
  days: [
    {
      number: 1,
      type: 'PORT',
      ports: [
        {
          activity: 'EMBARK',
          arrivalTime: null,
          departureTime: '16:30:00',
          port: {
            code: 'YVR',
            name: 'Vancouver',
            region: 'British Columbia',
            media: {
              images: [
                {
                  path: '/content/dam/royal/data/ports/vancouver/vancouver-british-columbia-bridge-night-time-city.jpg',
                  __typename: 'ImageMedia',
                },
              ],
              __typename: 'Media',
            },
            __typename: 'Port',
          },
          __typename: 'PortVisit',
        },
      ],
      __typename: 'Day',
    },
    {
      number: 2,
      type: 'PORT',
      ports: [
        {
          activity: 'CRUISING',
          arrivalTime: null,
          departureTime: null,
          port: {
            code: 'ISP',
            name: 'Inside Passage',
            region: 'Canada',
            media: {
              images: [
                {
                  path: '/content/dam/royal/content/fleet-landing/radiance-of-the-seas-aerial.jpg',
                  __typename: 'ImageMedia',
                },
              ],
              __typename: 'Media',
            },
            __typename: 'Port',
          },
          __typename: 'PortVisit',
        },
      ],
      __typename: 'Day',
    },
    {
      number: 3,
      type: 'PORT',
      ports: [
        {
          activity: 'DOCKED',
          arrivalTime: '06:00:00',
          departureTime: '16:00:00',
          port: {
            code: 'KTN',
            name: 'Ketchikan',
            region: 'Alaska',
            media: {
              images: [
                {
                  path: '/content/dam/royal/ports-and-destinations/destinations/Alaska/alaska-ketchikan-drone-aerial.jpg',
                  __typename: 'ImageMedia',
                },
              ],
              __typename: 'Media',
            },
            __typename: 'Port',
          },
          __typename: 'PortVisit',
        },
      ],
      __typename: 'Day',
    },
    {
      number: 4,
      type: 'PORT',
      ports: [
        {
          activity: 'DOCKED',
          arrivalTime: '08:00:00',
          departureTime: '17:00:00',
          port: {
            code: 'SIT',
            name: 'Sitka',
            region: 'Alaska',
            media: {
              images: [
                {
                  path: '/content/dam/royal/data/ports/sitka/sitka-alaska-volcano-mountain-sunset.jpg',
                  __typename: 'ImageMedia',
                },
              ],
              __typename: 'Media',
            },
            __typename: 'Port',
          },
          __typename: 'PortVisit',
        },
      ],
      __typename: 'Day',
    },
    {
      number: 5,
      type: 'PORT',
      ports: [
        {
          activity: 'DOCKED',
          arrivalTime: '07:00:00',
          departureTime: '21:30:00',
          port: {
            code: 'JNU',
            name: 'Juneau',
            region: 'Alaska',
            media: {
              images: [
                {
                  path: '/content/dam/royal/ports-and-destinations/destinations/Alaska/alaska-juneau-paddle-board-single-mountains-glaciers.jpg',
                  __typename: 'ImageMedia',
                },
              ],
              __typename: 'Media',
            },
            __typename: 'Port',
          },
          __typename: 'PortVisit',
        },
      ],
      __typename: 'Day',
    },
    {
      number: 6,
      type: 'PORT',
      ports: [
        {
          activity: 'TENDERED',
          arrivalTime: '07:00:00',
          departureTime: '17:00:00',
          port: {
            code: 'SGY',
            name: 'Skagway',
            region: 'Alaska',
            media: {
              images: [
                {
                  path: '/content/dam/royal/data/ports/skagway/skagway-alaska-bridge-train-transportation.jpg',
                  __typename: 'ImageMedia',
                },
              ],
              __typename: 'Media',
            },
            __typename: 'Port',
          },
          __typename: 'PortVisit',
        },
      ],
      __typename: 'Day',
    },
    {
      number: 7,
      type: 'PORT',
      ports: [
        {
          activity: 'CRUISING',
          arrivalTime: '09:00:00',
          departureTime: '11:30:00',
          port: {
            code: 'YAK',
            name: 'Hubbard Glacier',
            region: 'Alaska',
            media: {
              images: [
                {
                  path: '/content/dam/royal/content/fleet-landing/radiance-of-the-seas-aerial.jpg',
                  __typename: 'ImageMedia',
                },
              ],
              __typename: 'Media',
            },
            __typename: 'Port',
          },
          __typename: 'PortVisit',
        },
      ],
      __typename: 'Day',
    },
    {
      number: 8,
      type: 'PORT_TOUR',
      ports: [
        {
          activity: 'DEBARK',
          arrivalTime: '05:00:00',
          departureTime: null,
          port: {
            code: 'SWD',
            name: 'Seward',
            region: 'Alaska',
            media: {
              images: [
                {
                  path: '/content/dam/royal/data/ports/seward/seward-alaska-resurrection-bay-kayaking-nature-mountains-ocean.jpg',
                  __typename: 'ImageMedia',
                },
              ],
              __typename: 'Media',
            },
            __typename: 'Port',
          },
          __typename: 'PortVisit',
        },
        {
          activity: 'TOURING',
          arrivalTime: null,
          departureTime: null,
          port: {
            code: 'SWD',
            name: 'Seward',
            region: 'Alaska',
            media: {
              images: [
                {
                  path: '/content/dam/royal/data/ports/seward/seward-alaska-houses-along-mountain-oceanfront-views.jpg',
                  __typename: 'ImageMedia',
                },
              ],
              __typename: 'Media',
            },
            __typename: 'Port',
          },
          __typename: 'PortVisit',
        },
      ],
      __typename: 'Day',
    },
    {
      number: 9,
      type: 'TOUR',
      ports: [
        {
          activity: 'TOURING',
          arrivalTime: null,
          departureTime: null,
          port: {
            code: 'DNL',
            name: 'MISSING PORT CONTENT',
            region: null,
            media: {
              images: [],
              __typename: 'Media',
            },
            __typename: 'Port',
          },
          __typename: 'PortVisit',
        },
      ],
      __typename: 'Day',
    },
    {
      number: 10,
      type: 'TOUR',
      ports: [
        {
          activity: 'TOURING',
          arrivalTime: null,
          departureTime: null,
          port: {
            code: 'DNL',
            name: 'MISSING PORT CONTENT',
            region: null,
            media: {
              images: [],
              __typename: 'Media',
            },
            __typename: 'Port',
          },
          __typename: 'PortVisit',
        },
      ],
      __typename: 'Day',
    },
    {
      number: 11,
      type: 'TOUR',
      ports: [
        {
          activity: 'TOURING',
          arrivalTime: null,
          departureTime: null,
          port: {
            code: 'FAI',
            name: 'MISSING PORT CONTENT',
            region: null,
            media: {
              images: [],
              __typename: 'Media',
            },
            __typename: 'Port',
          },
          __typename: 'PortVisit',
        },
      ],
      __typename: 'Day',
    },
    {
      number: 12,
      type: 'TOUR',
      ports: [
        {
          activity: 'DEBARK',
          arrivalTime: null,
          departureTime: null,
          port: {
            code: 'FAI',
            name: 'MISSING PORT CONTENT',
            region: null,
            media: {
              images: [],
              __typename: 'Media',
            },
            __typename: 'Port',
          },
          __typename: 'PortVisit',
        },
      ],
      __typename: 'Day',
    },
  ],
  departurePort: {
    code: 'YVR',
    name: 'Vancouver',
    region: 'British Columbia',
    __typename: 'Port',
  },
  destination: {
    code: 'ALCAN',
    name: 'Alaska',
    __typename: 'Destination',
  },
  name: 'Wilderness Frontier Explorer Cruisetour 4A (Post Tour)',
  postTour: {
    days: [
      {
        number: 8,
        type: 'PORT_TOUR',
        ports: [
          {
            activity: 'TOURING',
            arrivalTime: null,
            departureTime: null,
            port: {
              code: 'SWD',
              name: 'Seward',
              region: 'Alaska',
              __typename: 'Port',
            },
            __typename: 'PortVisit',
          },
        ],
        __typename: 'Day',
      },
      {
        number: 9,
        type: 'TOUR',
        ports: [
          {
            activity: 'TOURING',
            arrivalTime: null,
            departureTime: null,
            port: {
              code: 'DNL',
              name: 'Denali',
              region: 'Alaska',
              __typename: 'Port',
            },
            __typename: 'PortVisit',
          },
        ],
        __typename: 'Day',
      },
      {
        number: 10,
        type: 'TOUR',
        ports: [
          {
            activity: 'TOURING',
            arrivalTime: null,
            departureTime: null,
            port: {
              code: 'DNL',
              name: 'Denali',
              region: 'Alaska',
              __typename: 'Port',
            },
            __typename: 'PortVisit',
          },
        ],
        __typename: 'Day',
      },
      {
        number: 11,
        type: 'TOUR',
        ports: [
          {
            activity: 'TOURING',
            arrivalTime: null,
            departureTime: null,
            port: {
              code: 'FAI',
              name: 'Fairbanks',
              region: 'Alaska',
              __typename: 'Port',
            },
            __typename: 'PortVisit',
          },
        ],
        __typename: 'Day',
      },
    ],
    duration: 4,
    __typename: 'Tour',
  },
  preTour: null,
  sailingNights: 7,
  ship: {
    code: 'RD',
    name: 'Radiance of the Seas',
    media: {
      images: [
        {
          path: '/content/dam/royal/content/fleet-landing/radiance-of-the-seas-aerial.jpg',
          __typename: 'ImageMedia',
        },
      ],
      __typename: 'Media',
    },
    __typename: 'Ship',
  },
  totalNights: 11,
  type: 'CRUISETOUR',
  __typename: 'Itinerary',
};

export const ACTIVITIES = [
  'EMBARK',
  'DEBARK',
  'DOCKED',
  'TENDERED',
  'CRUISING',
];

export const CRUISING_CODES = ['ASE', 'CRU', 'IDL'];

export const POST_TOUR = 'postTour';

export const QUICKBOOK_SESSION_KEY = 'rsQuickbook';
